import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { SubscriptionInfoPublic } from '../fragments';

export default gql`
  mutation actionSubscriptionUnpause($input: SubscriptionUnpauseActionInput!) {
    actionSubscriptionUnpause(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      subscription {
        ...SubscriptionInfoPublic
      }
    }
  }
  ${SubscriptionInfoPublic}
  ${ErrorMessageInfo}
`;
